export default __webpack_public_path__ + "static/media/LOGO_FALCON_BLANCO.ce348407.svg";